var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import styled from 'styled-components';
import { Popup } from 'react-map-gl';
import { Box } from '@thinkingmachines/asimov';
export const Tooltip = styled((_a) => {
    var { className, children, hoveredData, render } = _a, props = __rest(_a, ["className", "children", "hoveredData", "render"]);
    return (React.createElement(React.Fragment, null, hoveredData.lngLat ? (React.createElement(Popup, Object.assign({ className: className }, props, { latitude: hoveredData.lngLat[1], longitude: hoveredData.lngLat[0] }),
        React.createElement(Box, null, render(hoveredData.feature)))) : null));
}) `
  .mapboxgl-popup-content {
    padding: 5px 5px 5px;
    background: ${props => props.background};
  }
  .mapboxgl-popup-tip {
    border-bottom-color: ${props => props.background};
  }
`;
export const useMapboxTooltip = layers => {
    const [hovered, setHovered] = useState({});
    const onHover = event => {
        const { features, lngLat } = event;
        const feature = features &&
            features.find(f => Array.isArray(layers)
                ? layers.includes(f.layer.id)
                : f.layer.id === layers);
        if (feature) {
            setHovered({ feature, lngLat: lngLat });
        }
        else {
            setHovered({});
        }
    };
    return [hovered, onHover];
};
export const useDeckGlTooltip = layers => {
    const [hovered, setHovered] = useState({});
    const onHover = (info, event) => {
        const feature = info.layer &&
            (Array.isArray(layers)
                ? layers.includes(info.layer.id)
                : info.layer.id === layers)
            ? info
            : null;
        const { coordinate: lngLat } = info;
        if (feature) {
            setHovered({ feature: info.object, lngLat: lngLat });
        }
        else {
            setHovered({});
        }
    };
    return [hovered, onHover];
};
//# sourceMappingURL=Tooltip.js.map